/* eslint-disable camelcase */
import { combineReducers } from 'redux';
import axios from 'axios';
import { startSubmit, stopSubmit } from 'redux-form';

import { SYNC_ATTENDANCE_FORM } from 'src/constants/FormNames';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import { setItem } from 'src/reducers/common/itemReducer';
import { NEW_API_USER, VERIFY_CUSTOM_API_TOKEN } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';

export const REDUCER_NAME = 'syncWithAttendance';

const prepareData = (formData, client) => dispatch => {
  const isAttendanceValid = formData?.api_attendance_id && formData?.api_attendance_token;
  if (!isAttendanceValid || !client) {
    dispatch(stopSubmit(SYNC_ATTENDANCE_FORM));
    dispatch(setItem(REDUCER_NAME, { text: 'Error: Invalid data', status: 400 }));
    return;
  }

  // eslint-disable-next-line consistent-return
  return {
    client_api_user: {
      payroll_client_id: client.id,
      client_code: client.clientCode,
      api_attendance_id: formData?.api_attendance_id,
      api_attendance_token: formData?.api_attendance_token
    }
  };
};

const prepareCheckLastSync = data => ({
  client_api_user: {
    payroll_client_id: data.id,
    client_code: data.clientCode
  }
});

export const saveToken = (data, client) => async dispatch => {
  dispatch(startSubmit(SYNC_ATTENDANCE_FORM));

  const dispatchStopSubmitAndSetItem = item => {
    dispatch(stopSubmit(SYNC_ATTENDANCE_FORM));
    dispatch(setItem(REDUCER_NAME, item));
  };

  try {
    const preparedData = prepareData(data, client)(dispatch);
    if (!preparedData.client_api_user.client_code) {
      dispatchStopSubmitAndSetItem({ text: 'Error: The client code is invalid', status: 400 });
      return;
    }

    const API_URL = concatParamsToUrl(NEW_API_USER, { client_id: client.id }, {});

    const response = await axios.post(API_URL, preparedData);
    if (response.status === 200) {
      dispatchStopSubmitAndSetItem({ text: response.data.message, status: response.status, synced: true });
    }
  } catch (error) {
    dispatchStopSubmitAndSetItem({ text: error.message, status: 500 });
  }
};

export const checkLastSync = data => async (dispatch, isLoading) => {
  try {
    isLoading(true);
    // eslint-disable-next-line no-shadow
    const prepareData = prepareCheckLastSync(data);
    const API_URL = concatParamsToUrl(VERIFY_CUSTOM_API_TOKEN, { clientId: data.id });
    const response = await axios.post(API_URL, prepareData);
    dispatch(setItem(REDUCER_NAME, { text: response.data.message, status: response.status, synced: true }));
  } catch (error) {
    dispatch(
      setItem(REDUCER_NAME, {
        text: error.response.data,
        status: error.response.status
      })
    );
  } finally {
    isLoading(false);
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
